import { createContext } from "react";

export const ModalsContext = createContext({
  data: Object(),
  setData: (data: any) => {},
  checkData: false,
  setDataChecking: (data: React.SetStateAction<boolean>) => {},
});
